import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2f1e84c9")

_pushScopeId("data-v-2f1e84c9")
const _hoisted_1 = {
  class: "tabs-enum-filter p-tabview-nav",
  role: "tablist"
}
const _hoisted_2 = { class: "p-tabview-title d-inline-flex align-items-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("ul", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.enumProps, (value, prop) => {
      return _withDirectives((_openBlock(), _createBlock("li", {
        key: prop,
        class: { 'p-highlight': _ctx.selectedTab === value }
      }, [
        _createVNode("a", {
          role: "tab",
          onClick: ($event: any) => (_ctx.selectTab(value)),
          class: "p-tabview-nav-link",
          "aria-selected": "false"
        }, [
          _createVNode("span", _hoisted_2, [
            _renderSlot(_ctx.$slots, "icon-label"),
            _createTextVNode(" " + _toDisplayString(prop), 1)
          ])
        ], 8, ["onClick"])
      ], 2)), [
        [_vShow, _ctx.isTabShown(value)]
      ])
    }), 128))
  ]))
})